import React from 'react';
import { Flex } from '@withjoy/joykit';
import { Home } from '@withjoy/joykit/icons';
import { useRouterHelper, useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';
import { useEventTypeConfig } from '@shared/utils/eventType';
import { MenuItem } from './components/BurgerMenu/MenuItem';
import { routePaths } from '@apps/admin/route.paths';
import { useDashboardTelemetry } from '@apps/admin/routes/Dashboard/Dashboard.telemetry';
import { GLOBAL_NAV_MENU } from './UniversalBurgerMenu.controller';
import { EventFeature, useProFeature } from '@shared/hooks/useProFeature';
import { useEventInfo } from '@shared/utils/eventInfo';

export const MenuHeader = () => {
  const t = useTranslation('sharedRegistry').t2('registryNavigationMenu');
  const { config } = useEventTypeConfig();
  const { buildPath } = useRouterHelper();
  const telemetry = useDashboardTelemetry();
  const carbonDashboardEnabled = useProFeature(EventFeature.carbonDashboard);
  const { eventInfo } = useEventInfo();
  const eventId = eventInfo?.eventId;
  const useCarbonDashboard = carbonDashboardEnabled && eventId;

  const dashboardInfo = useCarbonDashboard
    ? {
        // When an event is created via carbon we want the dashboard to route to the carbon dashboard
        path: `/carbon/edit/event/${eventId}`,
        telemetry: { label: 'carbonDashboard', section: 'Carbon Dashboard', categoryArg: GLOBAL_NAV_MENU },
      }
    : {
        // Default dashboard routing
        path: buildPath(routePaths.dashboard.path),
        telemetry: { label: 'eventDashboard', section: 'Event Dashboard', categoryArg: GLOBAL_NAV_MENU },
      };

  return config?.eventDashboardEnabled ? (
    <Flex
      flexDirection="column"
      rowGap={pxToRem(24)}
    >
      <MenuItem
        typographyVariant="hed2"
        fontWeight={600}
        text={t.eventDashboard}
        icon={Home}
        path={dashboardInfo.path}
        pathIsInJoyWeb={!useCarbonDashboard}
        onClick={() => telemetry.openPage(dashboardInfo.telemetry)}
      />
    </Flex>
  ) : (
    <></>
  );
};
